import { SkillColor } from 'sierra-client/features/skills/colors'
import { SkillIconId } from 'sierra-ui/components'
import { z } from 'zod'

export const BadgeTheme = z.enum([...SkillColor.options, 'disabled'])
export type BadgeTheme = z.infer<typeof BadgeTheme>

export const BadgeIconId = z.enum([...SkillIconId.options, 'locked'])
export type BadgeIconId = z.infer<typeof BadgeIconId>
